export default __webpack_public_path__ + "static/media/296.ae0ff6de.jpg";